import { render, staticRenderFns } from "./flowDetail.vue?vue&type=template&id=ffab9f08&scoped=true&"
import script from "./flowDetail.vue?vue&type=script&lang=js&"
export * from "./flowDetail.vue?vue&type=script&lang=js&"
import style0 from "./flowDetail.vue?vue&type=style&index=0&id=ffab9f08&lang=scss&scoped=true&"
import style1 from "./flowDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffab9f08",
  null
  
)

export default component.exports